import { ActionTree, MutationTree } from "vuex";
import { IRootState } from "@iloq/shared";
import config from "@/config";

export interface IIframesState {
  extranetProductsUrl: string;
  extranetOrdersUrl: string;
  extranetLicensesUrl: string;
  extranetShoppingCartUrl: string;
  academyWindow?: any;
  saabIframeBaseUrl: string;
}

const initialState: IIframesState = {
  extranetProductsUrl: config.get("extranetUrlForProducts"),
  extranetOrdersUrl: config.get("extranetUrlForOrders"),
  extranetLicensesUrl: config.get("extranetUrlForLicenses"),
  extranetShoppingCartUrl: config.get("extranetUrlForShoppingCart"),
  saabIframeBaseUrl: config.get("saabIframeBaseUrl"),
};

const actions: ActionTree<IRootState, IRootState> = {};

const mutations: MutationTree<IIframesState> = {
  clearIframeUrls(state: IIframesState): void {
    const emptyUrl = "about:blank";
    state.extranetProductsUrl = emptyUrl;
    state.extranetOrdersUrl = emptyUrl;
    state.extranetLicensesUrl = emptyUrl;
    state.extranetShoppingCartUrl = emptyUrl;
    state.saabIframeBaseUrl = emptyUrl;
  },
  setIframeUrlsFromConfig(state: IIframesState): void {
    state.extranetProductsUrl = config.get("extranetUrlForProducts");
    state.extranetOrdersUrl = config.get("extranetUrlForOrders");
    state.extranetLicensesUrl = config.get("extranetUrlForLicenses");
    state.extranetShoppingCartUrl = config.get("extranetUrlForShoppingCart");
    state.saabIframeBaseUrl = config.get("saabIframeBaseUrl");
  },
  setAcademyWindow(state: IIframesState, academyWindow: any): void {
    state.academyWindow = academyWindow;
  },
  closeAcademyWindow(state: IIframesState): void {
    if (state.academyWindow) {
      state.academyWindow.close();
      state.academyWindow = undefined;
    }
  },
};

export const iframesModule = {
  actions,
  mutations,
  state: initialState,
  namespaced: true,
};
